import { render, staticRenderFns } from "./ArtistsCarrousel.vue?vue&type=template&id=21d854fe&scoped=true&"
import script from "./ArtistsCarrousel.vue?vue&type=script&lang=js&"
export * from "./ArtistsCarrousel.vue?vue&type=script&lang=js&"
import style0 from "./ArtistsCarrousel.vue?vue&type=style&index=0&id=21d854fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d854fe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
